/**
 * Shared helper — detect the "AZAI platform staff without an active
 * elevation" 403 response from the backend so pages can render a
 * helpful CTA banner instead of the misleading generic "Failed to
 * load X" toast.
 *
 * Backend response shape (Phase 6 platform-elevation model):
 *   HTTP 403
 *   { detail: { error: 'elevation_required', message: '...' } }
 *
 * Some older routes surface it as a plain string:
 *   { detail: 'Elevation required for this action' }
 *
 * Callers use this in their axios `.catch` block:
 *
 *   } catch (err) {
 *     if (isElevationRequired(err)) {
 *       setNeedsElevation(true);
 *       return;
 *     }
 *     toast.error('Failed to load ...');
 *   }
 */
export const isElevationRequired = (err) => {
  if (err?.response?.status !== 403) return false;
  const detail = err?.response?.data?.detail;
  if (typeof detail === 'string') return detail.toLowerCase().includes('elevation');
  if (detail && typeof detail === 'object') {
    return detail.error === 'elevation_required';
  }
  return false;
};
